export default __webpack_public_path__ + "static/media/Mark-3-HUD-Targeting (Reticle).ac8690e3.jpg";